import React from "react";
import Avatar from "../../avatar";
import GcAvatar from "../../gcAvatar";

const PostHeader = ({
	avatarPhotoUrl = null,
	title = null,
	meta = null,
	extra = "",
	dimension = "thumb6",
}: {
	avatarPhotoUrl?: string;
	title?: string;
	meta?: string;
	extra?: string;
	dimension?: string;
}) => (
	<div className={`item postHeader ${extra}`}>
		{avatarPhotoUrl ? (
			<div className="itemImage">
				<Avatar className="club" photoUrl={avatarPhotoUrl.replace("_DIMENSION_", dimension)} />
			</div>
		) : null}
		{extra && extra == "gotcourts" ? (
			<div className="itemImage">
				<GcAvatar className="club" />
			</div>
		) : null}
		{extra && extra == "st" ? (
			<div className="itemImage">
				<div className="avatar st club"></div>
			</div>
		) : null}
		<div className="itemBody">
			<div className="title">{title}</div>
			<div className="meta">
				<div className="longTextWrap">
					<div className="longText">{meta}</div>
				</div>
			</div>
		</div>
	</div>
);

export default PostHeader;
